import React from 'react';
import Hero from '../components/Hero';
import WhatWeDo from '../components/WhatWeDo';
import OurTechnology from '../components/OurTechnology';
import Principles from '../components/Principles';
import GlobalImpact from '../components/GlobalImpact';

const Home = () => {
  return (
    <>
      <Hero />
      <WhatWeDo />
      <OurTechnology />
      <Principles />
      <GlobalImpact />
    </>
  );
};

export default Home;
